import * as editChecks from '../../../constants/EstablishmentEditConstants.js';
import * as errorMessages from '../../../constants/errorMessages';

export default function confirmFormIsValid(establishment, activeFields, requiredFields, establishments = []) {
  let formIsValid = true;
  let errors = {};
  if (establishment.establishment_status == 2) {
    formIsValid = false;
  }
  let repeatedEstablishment = establishments.filter(estab => {
    return estab.establishment_name.toUpperCase() === establishment.establishmentName.toUpperCase();
  })[0];

  if (requiredFields) {
    requiredFields.map(questionPart => {
      let fieldName = questionPart.questionPartName;
      let label = questionPart.questionPartLabel;
      if (!establishment[fieldName]) {
        formIsValid = false;
        if (activeFields.indexOf(fieldName) !== -1) {
          if (fieldName === 'size') {
            errors[fieldName] = "Establishment Size " + errorMessages.ERROR_NEEDS_VALUE;
          } else if (fieldName === 'streetAddress') {
            errors[fieldName] = "Street Address " + errorMessages.ERROR_NEEDS_VALUE;
          } else if (fieldName === "naics") {
            errors[fieldName] = "NAICS " + errorMessages.ERROR_NEEDS_VALUE;
          } else if (fieldName === "zipCode") {
            errors[fieldName] = "Zip Code " + errorMessages.ERROR_NEEDS_VALUE;
          } else {
            errors[fieldName] = label + errorMessages.ERROR_NEEDS_VALUE;
          }

        }
      }
    });
  }

  if (repeatedEstablishment) {
    formIsValid = false;
    errors.establishmentName = errorMessages.ERROR_REPEATED_ESTABLISHMENT;
  }
  if (establishment.zipCode) {
    let message = validateZipCode(establishment.zipCode);
    if (message != '') {
      formIsValid = false;
      errors.zipCode = message;
    }
  }
  if (establishment.naics) {
    const naics = establishment.naics;
    let naicsCode = naics;

    if (naics.length > 6) {
      naicsCode = naics.split(" ")[0];
    }

    let message = validateNAICSCode(naicsCode);
    if (message != '') {
      formIsValid = false;
      errors.naics = message;
    } else if (establishment.naicsIsInvalid) {
      formIsValid = false;
      errors.naics = errorMessages.NO_NAICS_DATA_RETURNED;
    }
  }
  if (establishment.ein) {
    let message = validateEinNumber(establishment.ein);
    if (message != '') {
      formIsValid = false;
      errors.ein = message;
    }
  }

  return {formIsValid, errors, repeatedEstablishment};
}

function validateZipCode(zipCode) {
  let msg = '';
  /*
   *first five characters any a letter, Zip code must contain only numbers
   if under 5 characters zip code must contain 5 digits
   zip code add-on must contain numbers
   zip code add on must contain 4 digits
   */
  if (zipCode.length <= editChecks.minZipLen) {
    if (zipCode.length !== editChecks.minZipLen) {
      msg = errorMessages.ERROR_MIN_ZIPCODE;
    } else if (!zipCode.match(editChecks.REG_EX_NUMERIC)) {
      msg = errorMessages.ERROR_LETTER_IN_ZIPCODE;
    }
  } else if (zipCode.length > editChecks.minZipLen) {
    if (zipCode.length !== editChecks.maxZipLen || !zipCode.match(editChecks.zipCodePattern)) {
      msg = errorMessages.ERROR_MIN_ZIPCODE_ADD_ON;
    }
    if (!zipCode.slice(6, 9).match(editChecks.REG_EX_NUMERIC)) {
      msg = errorMessages.ERROR_LETTER_IN_ZIPCODE_ADD_ON;
    }

  }

  return msg;
}

function validateNAICSCode(naicsCode) {
  naicsCode = naicsCode.toString();
  let msg = '';
  if (!naicsCode) {
    msg = errorMessages.NAICS_NOT_ENTERED;
  }
  if (naicsCode && naicsCode.length !== editChecks.maxNAICSLen || naicsCode > editChecks.maxNAICSVal) {
    msg = errorMessages.ERROR_NAICS_WRONG_FORMAT;
  } else if (naicsCode && !naicsCode.match(editChecks.REG_EX_NUMERIC)) {
    msg = errorMessages.ERROR_NEEDS_TO_BE_A_NUMBER;
  }
  return msg;
}

function validateEinNumber(ein) {
  let msg = '';
  /*
   *EIN can't be 9 ones  
    EIN can't be 9 zeros
    EIN can't be 123456789
   */
   if (ein.length !== editChecks.einLen) {
     msg = errorMessages.ERROR_EIN_BADFORMAT;
   }
   if (!ein.match(editChecks.REG_EX_NUMERIC)) {
      msg = errorMessages.ERROR_NEEDS_TO_BE_A_NUMBER;
   }
   if (ein == '000000000') {
      msg = errorMessages.ERROR_EIN_BADFORMAT;
   }
   else if(ein == '111111111') {
      msg = errorMessages.ERROR_EIN_BADFORMAT;
   }
   else if (ein == '123456789') {
      msg = errorMessages.ERROR_EIN_BADFORMAT;
   }
   return msg;
}



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentManagement/EstablishmentEditChecks.js
 **/